import { useEffect } from "react";
import { usePrevious } from "../../../core";
import { SimpleSelect, SimpleSelectProps } from "../../inputs";
import { TableColumnDef } from "../types";

import styles from "./styles.module.scss";

export function SimpleSelectColumn<T extends object = {}, TValue extends string | number | boolean = string>(
  { simpleSelectProps, ...params }: TableColumnDef<T> & {
    simpleSelectProps?: SimpleSelectProps<TValue>
  },
): TableColumnDef<T> {
  return {
    enableColumnFilter: true,
    minSize: 50,
    cell: ({ renderValue }) => <span className={styles.content}>{renderValue() as any}</span>,
    ...params,
    meta: {
      defaultFilterFn: "equals",
      additionalFilterFn: [ "equals", "arrIncludesSome" ],
      Filter: ({ label, value, onChange, autoFocus, filterFn }) => {
        const previousFilterFn = usePrevious(filterFn);
        const isMulti = filterFn.toString()
          .includes("arrIncludes");

        useEffect(() => {
          if (!!previousFilterFn && previousFilterFn !== filterFn) {
            if (isMulti) {
              onChange([ value ]);
            } else {
              onChange(Array.isArray(value) ? value?.[0] : null);
            }
          }
        }, [ filterFn, onChange, previousFilterFn, value, isMulti ]);

        return (
          <SimpleSelect<TValue>
            autoFocus={autoFocus}
            label={label}
            value={value as any}
            onChange={onChange}
            isMulti={isMulti}
            {...simpleSelectProps}
          />
        );
      },
      ...params?.meta,
      excelProps: {
        valueModifier: simpleSelectProps?.getOptionLabel as any,
        filterButton: true,
        ...params?.meta?.excelProps,
      },
    },
  };
}
